// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Staff Container */
.staff-container {
    /* max-width: 90%;  */
    min-height: 100vh; 
    margin: 2rem;
    padding: 20px;
    /* background-color: var(--clr-primary-10); */
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    font-family: var(--ff-primary);
    box-sizing: border-box;
    margin-top: 4rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 3px solid var(--clr-primary-3);
}

/* Header Section */
.staff-header {
    text-align: center;
    margin-bottom: 2rem;
}

.staff-header h1 {
    color: var(--clr-primary-5);
    font-size: 2rem;
    font-weight: bold;
}

.staff-header p {
    color: var(--clr-grey-3);
    font-size: 1rem;
    max-width: 700px;
    margin: 0 auto;
}

/* Summary Section */
.staff-summary {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    gap: 1rem; 
    flex-wrap: wrap; 
}

.summary-card {
    background-color: var(--clr-white);
    padding: 1.5rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    text-align: center;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(25% - 1rem); 
    margin: 0.5rem; 
    transition: var(--transition);
    cursor: pointer;
    max-width: 100%; 
}

.summary-card h3 {
    color: var(--clr-primary-5);
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
}

.summary-card p {
    color: var(--clr-grey-2);
    font-size: 1.5rem;
    font-weight: bold;
}

.summary-card:hover {
    transform: translateY(-5px);
    box-shadow: var(--dark-shadow);
}

.summary-card:active {
    transform: translateY(2px);
    box-shadow: var(--light-shadow);
}

/* Responsive Design */
@media (max-width: 1024px) {
    .summary-card {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(33% - 1rem); 
    }
}

@media (max-width: 768px) {
    .staff-summary {
        flex-direction: column;
        gap: 1rem;
    }
    
    .summary-card {
        flex: 1 1 100%; 
    }
}

@media (max-width: 480px) {
    .summary-card h3 {
        font-size: 1rem;
    }

    .summary-card p {
        font-size: 1.25rem;
    }
}

/* Pagination */
.pagination-nav {
    display: flex;
    justify-content: center;
    margin: 1.5rem 0;
}

.pagination {
    display: flex;
    list-style: none;
    padding: 0;
}

.page-item {
    margin: 0 0.5rem;
}

.page-link {
    padding: 0.5rem 1rem;
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
}

.page-item.active .page-link {
    background-color: var(--clr-primary-7);
}

.page-link:hover {
    background-color: var(--clr-primary-4);
}

/* Tabs Navigation */
.staff-tabs {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap; 
    gap: 0.5rem;    
    margin-bottom: 1.5rem;
    background-color: var(--clr-grey-10);
    padding: 1rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
  }
  
  /* Button class for tab buttons */
  .staff-tab-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(20% - 1rem); 
    min-width: 120px;         
    padding: 0.75rem 1.5rem;
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
    font-size: 1.1rem;
    margin: 0.25rem; 
  }

.staff-tab-btn:hover {
    background-color: var(--clr-primary-6); 
}

/* Active tab class */
.staff-tab-btn.active {
    background-color: var(--clr-primary-7); 
    box-shadow: var(--dark-shadow); 
    font-weight: bold; 
}

.staff-tab-btn:focus {
    outline: none; 
}

/* Class for active tab with a different background */
.staff-tab-btn.active-tab {
    background-color: var(--clr-grey-2); 
    box-shadow: var(--dark-shadow); 
    font-weight: bold; 
    color: var(--clr-primary-9); 
}

/* Hover effect for the active tab */
.staff-tab-btn.active-tab:hover {
    background-color: var(--clr-grey-1); 
    box-shadow: var(--light-shadow); 
}

.staff-tab-btn:disabled {
    background-color: #ddd;
    cursor: not-allowed;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .staff-tab-btn {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: calc(50% - 1rem); /* ✅ 2 per row */
      padding: 0.75rem;
      font-size: 0.875rem;
      text-align: center;
    }
  }
  
  @media (max-width: 480px) {
    .staff-tab-btn {
      flex: 1 1 100%; 
      font-size: 0.75rem;
      padding: 0.5rem;
    }
  }
.staff-tab-btn:hover {
    background-color: var(--clr-primary-4);
    box-shadow: var(--dark-shadow);
}

/* Staff Content */
.staff-content {
    padding: 2rem;
    background-color: var(--clr-white);
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
}

/* Forms */
.staff-container form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    background-color: var(--clr-white);
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
}
  
.staff-container input[type="text"],
.staff-container input[type="email"],
.staff-container input[type="number"] {
    padding: 0.75rem;
    border: 1px solid var(--clr-grey-6);
    border-radius: var(--radius);
    font-size: 1rem;
    color: var(--clr-grey-3);
}

.staff-container select {
    padding: 0.75rem;
    border: 1px solid var(--clr-grey-6);
    border-radius: var(--radius);
    font-size: 1rem;
    color: var(--clr-grey-3);
    width: 100%;
    box-sizing: border-box;
}

.staff-container .staff-btn {
    padding: 0.75rem;
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
    font-size: 1rem;
}

/* Responsive for medium screens (tablets) */
@media (max-width: 768px) {
    .staff-container .staff-btn {
        padding: 0.6rem; 
        font-size: 0.9rem; 
        width: auto; 
    }
}

/* Responsive for small screens (mobile phones) */
@media (max-width: 480px) {
    .staff-container .staff-btn {
        padding: 0.5rem; 
        font-size: 0.85rem; 
        width: auto; 
    }
}

.staff-container .staff-btn:hover {
    background-color: var(--clr-primary-4);
    box-shadow: var(--dark-shadow);
}

/* Practitioner List */
.practitioner-list ul {
    list-style-type: none;
    padding: 0;
}

.practitioner-list li {
    padding: 1rem;
    background-color: var(--clr-primary-10);
    border-radius: var(--radius);
    margin-bottom: 1rem;
    box-shadow: var(--light-shadow);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.practitioner-list li span {
    color: var(--clr-grey-2);
}

/* Responsive Design */
@media (max-width: 768px) {
    .staff-container form {
        padding: 1rem;
    }
  
    .practitioner-list li {
        flex-direction: column;
        align-items: flex-start;
    }
  
    .practitioner-list li span {
        margin-bottom: 0.5rem;
    }
}


/* Banner */
.banner {
    padding: 1rem;
    margin-bottom: 1rem;
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    text-align: center;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
}

/* Recent Activity Section */
.recent-activity {
    margin-top: 2rem;
    background-color: var(--clr-grey-10);
    padding: 1.5rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
}

.recent-activity h2 {
    color: var(--clr-primary-5);
    margin-bottom: 1rem;
    text-align: center;
}

.recent-activity ul {
    list-style-type: none;
    padding-left: 0;
    color: var(--clr-grey-3);
}

.recent-activity li {
    margin-bottom: 0.75rem;
    padding: 0.75rem;
    background-color: var(--clr-white);
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.activity-added {
    color: var(--clr-green);
}

.activity-updated {
    color: var(--clr-blue);
}

.activity-removed {
    color: var(--clr-red);
}

.timestamp {
    color: var(--clr-grey-5);
    font-size: 0.875rem;
    margin-left: 0.5rem;
}

/* Responsive Design */
@media (max-width: 768px) {
    .recent-activity li {
        flex-direction: column;
        align-items: flex-start;
    }

    .timestamp {
        margin-top: 0.5rem;
    }
}

/* Empty State Styling */
.empty-state {
    text-align: center;
    padding: 2rem;
    background-color: var(--clr-white);
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    color: var(--clr-grey-3);
}

.empty-state p {
    margin: 0.5rem 0;
    font-size: 1rem;
    color: var(--clr-grey-4);
}

/* Mini Workflow Container */
.mini-workflow-container {
    width: 50%; 
    margin: 0 auto;
    padding: 15px;
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid var(--clr-primary-5);  
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    text-align: center;
}


.workflow-title {
    font-size: 1.4rem;
    font-weight: bold;
    color: #222;  
    margin-bottom: 8px;
}


.workflow-description {
    font-size: 1rem;
    color: #444; 
    text-align: left;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}


.workflow-description p {
    margin: 6px 0;
    font-weight: 500;
    /* display: flex; */
    align-items: center;
    gap: 10px;
    color: var(--clr-grey-1);
    /* font-size: 1rem; */
}


.workflow-icon {
    color: #ff8c00; 
    font-size: 1.2rem;
    flex-shrink: 0; 
}

/* Responsive Adjustments */
@media (max-width: 768px) {
    .mini-workflow-container {
        width: 90%; 
        padding: 12px;
    }

    .workflow-title {
        font-size: 1.2rem;
    }

    .workflow-description {
        font-size: 0.95rem;
    }

    .workflow-icon {
        font-size: 1rem; 
    }
}

/* Adjustments for smaller screens */
@media (max-width: 1024px) {
    .mini-workflow-container {
        width: 70%; 
    }
}

@media (max-width: 768px) {
    .mini-workflow-container {
        width: 90%; 
    }
}

@media (max-width: 480px) {
    .mini-workflow-container {
        width: 100%; 
        padding: 8px;
    }
}

/* Mini Search Input */
.mini-search-input {
    width: 100%; 
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
}

/* Adjust font size for smaller devices */
@media (max-width: 768px) {
    .mini-search-input {
        font-size: 0.9rem; 
    }
}

/* Mini Search Button */
.mini-search-btn {
    padding: 10px 15px;
    background-color: #009688;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

/* Adjust button size for smaller screens */
@media (max-width: 768px) {
    .mini-search-btn {
        padding: 8px 12px; 
        font-size: 0.9rem;
    }
}

/* Country Select */
.country-select {
    margin-bottom: 10px;
}

.country-select select {
    padding: 8px;
    font-size: 1rem;
    border-radius: 4px;
    border: 1px solid #ccc;
}

/* Adjust font size for smaller devices */
@media (max-width: 768px) {
    .country-select select {
        padding: 6px;
        font-size: 0.9rem; 
    }
}

/* Search Hint */
.search-hint {
    font-size: 0.85rem;
    color: #6c757d;
    margin-top: 0.5rem;
    font-style: italic;
}

/* Adjust search hint font size for smaller devices */
@media (max-width: 768px) {
    .search-hint {
        font-size: 0.75rem;
    }
}


.unlock-hint {
    font-size: 0.9rem;
    color: #ff9800; 
    text-align: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
    background-color: #fff3e0; 
    padding: 0.5rem;
    border-radius: 5px;
    border: 1px solid #ff9800;
}

.limit-hint {
    font-size: 1.2rem;
    color: #ff9800; 
    text-align: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
    background-color: #fff3e0; 
    padding: 0.5rem;
    border-radius: 5px;
    border: 1px solid #ff9800;
}

/* Custom Summary Section Styling */
.custom-staff-summary {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); 
    gap: 1.5rem;  
    margin-top: 1.5rem;
    padding: 1rem;
    background-color:var(--red-light);
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Custom Summary Card */
.custom-summary-card {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 1.5rem;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    width: 100%; 
    max-width: 100%; 
}

.custom-summary-card:hover {
    transform: translateY(-5px);  
}

/* Custom Pagination Styling - Separate container */
.custom-pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 2rem;  
}

.custom-pagination {
    list-style: none;
    padding: 0;
    display: flex;
}

.custom-pagination li {
    margin: 0 0.5rem;
}

.custom-pagination .page-link {
    padding: 0.5rem 1rem;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.custom-pagination .page-item.active .page-link {
    background-color: #007bff;
    color: white;
    border-color: #007bff;
}

.custom-pagination .page-link:hover {
    background-color: #f0f0f0;
}

.custom-summary-title {
    /* font-size: 1.75rem; 
    font-weight: 600;  */
    /* color: #007bff;   */
    color: var(--clr-primary-5);
    margin-bottom: 0.75rem; 
    letter-spacing: 0.5px; 
    text-transform: capitalize; 
    transition: color 0.3s ease; 
}

.custom-summary-title:hover {
    /* color: #0056b3;  */
    color: var(--clr-primary-3);
}

/* Styling for the h4 (No Practitioner Title) */
.custom-no-practitioner-title {
    font-size: 1.5rem; 
    font-weight: 600;  
    color: #333;  
    text-align: center;  
    margin-bottom: 1rem; 
}

/* Styling for the p (No Practitioner Description) */
.custom-no-practitioner-description {
    font-size: 1.1rem; 
    font-weight: 400;  
    color:var(--clr-grey-1);  
    text-align: center;  
    margin-bottom: 0.5rem; 
    line-height: 1.5;  
}

/* Custom Styling for the Manage Practitioners Title */
.custom-manage-title {
    color: var(--clr-grey-1); 
    font-size: 2rem;  
    font-weight: bold; 
    text-align: center;  
    margin-bottom: 1.5rem; 
    letter-spacing: 0.5px;  
    padding-bottom: 0.5rem;  
    margin-top: 4rem;
}


/* Stylings for logging out state */

/* Full Page Container for Logout State */
.full-page-logout-container {
    position: fixed; 
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh; 
    background-color: #f8f9fa; 
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999; 
}

.landing-page-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    /* background: var(--clr-primary-8); */
    font-family: var(--ff-primary);
    color: var(--clr-grey-1);
    padding: 1rem;
  }
  

/* Center the logout message in the middle */
.logout-message-container {
    background-color: #fff8f0;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #f5c6cb;
    max-width: 600px;
    text-align: center;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    animation: slideIn 0.6s ease-out, glowEffect 2s infinite alternate ease-in-out;
}

/* Title Styling with Color Change Animation */
.logout-message-title {
    color: #d9534f;
    font-size: 1.5rem;
    font-weight: bold;
    margin: 0;
    padding: 0;
    letter-spacing: 0.5px;
    animation: colorChange 3s infinite alternate ease-in-out;
}

/* Slide-in Animation */
@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-20%);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Glow Effect Animation for the Container */
@keyframes glowEffect {
    from {
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    }
    to {
        box-shadow: 0 4px 25px rgba(217, 83, 79, 0.5);
    }
}

/* Pulsating Color Change for Title */
@keyframes colorChange {
    from {
        color: #d9534f;
    }
    to {
        color: #c9302c;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/staff.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,6CAA6C;IAC7C,4BAA4B;IAC5B,+BAA+B;IAC/B,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,kBAAkB;IAClB,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA,sBAAsB;AACtB;IACI;QACI,YAA0B;QAA1B,cAA0B;QAA1B,4BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,eAAe;AACf;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,oCAAoC;IACpC,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA,iCAAiC;EACjC;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,gBAAgB;IAChB,uBAAuB;IACvB,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;EACjB;;AAEF;IACI,sCAAsC;AAC1C;;AAEA,qBAAqB;AACrB;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA,qDAAqD;AACrD;IACI,mCAAmC;IACnC,8BAA8B;IAC9B,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA,oCAAoC;AACpC;IACI,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI;MACE,YAA0B;MAA1B,cAA0B;MAA1B,4BAA0B,EAAE,gBAAgB;MAC5C,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,cAAc;MACd,kBAAkB;MAClB,eAAe;IACjB;EACF;AACF;IACI,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,kCAAkC;IAClC,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA,UAAU;AACV;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,kCAAkC;IAClC,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;;;IAGI,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,eAAe;IACf,wBAAwB;IACxB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;IAC7B,eAAe;AACnB;;AAEA,4CAA4C;AAC5C;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,WAAW;IACf;AACJ;;AAEA,iDAAiD;AACjD;IACI;QACI,eAAe;QACf,kBAAkB;QAClB,WAAW;IACf;AACJ;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA,sBAAsB;AACtB;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,4BAA4B;IAC5B,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;IACzB;AACJ;;;AAGA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,oCAAoC;IACpC,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,kCAAkC;IAClC,4BAA4B;IAC5B,+BAA+B;IAC/B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,aAAa;IACb,kCAAkC;IAClC,4BAA4B;IAC5B,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,wBAAwB;AAC5B;;AAEA,4BAA4B;AAC5B;IACI,UAAU;IACV,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;AACtB;;;AAGA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;;AAGA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,wBAAwB;IACxB,qBAAqB;AACzB;;;AAGA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,oCAAoC;AACpC;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,yCAAyC;AACzC;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA,2CAA2C;AAC3C;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,yCAAyC;AACzC;IACI;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,qDAAqD;AACrD;IACI;QACI,kBAAkB;IACtB;AACJ;;;AAGA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,iCAAiC;IACjC,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA,wBAAwB;AACxB;IACI,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;IACxC,+BAA+B;IAC/B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;wBACoB;IACpB,sBAAsB;IACtB,2BAA2B;IAC3B,sBAAsB;IACtB,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA,+CAA+C;AAC/C;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,oDAAoD;AACpD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,sDAAsD;AACtD;IACI,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;AACpB;;;AAGA,mCAAmC;;AAEnC,yCAAyC;AACzC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sCAAsC;IACtC,8BAA8B;IAC9B,wBAAwB;IACxB,aAAa;EACf;;;AAGF,4CAA4C;AAC5C;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,8EAA8E;AAClF;;AAEA,8CAA8C;AAC9C;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,qBAAqB;IACrB,wDAAwD;AAC5D;;AAEA,uBAAuB;AACvB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,4CAA4C;AAC5C;IACI;QACI,yCAAyC;IAC7C;IACA;QACI,6CAA6C;IACjD;AACJ;;AAEA,qCAAqC;AACrC;IACI;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":["/* Staff Container */\n.staff-container {\n    /* max-width: 90%;  */\n    min-height: 100vh; \n    margin: 2rem;\n    padding: 20px;\n    /* background-color: var(--clr-primary-10); */\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n    font-family: var(--ff-primary);\n    box-sizing: border-box;\n    margin-top: 4rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    border: 3px solid var(--clr-primary-3);\n}\n\n/* Header Section */\n.staff-header {\n    text-align: center;\n    margin-bottom: 2rem;\n}\n\n.staff-header h1 {\n    color: var(--clr-primary-5);\n    font-size: 2rem;\n    font-weight: bold;\n}\n\n.staff-header p {\n    color: var(--clr-grey-3);\n    font-size: 1rem;\n    max-width: 700px;\n    margin: 0 auto;\n}\n\n/* Summary Section */\n.staff-summary {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 2rem;\n    gap: 1rem; \n    flex-wrap: wrap; \n}\n\n.summary-card {\n    background-color: var(--clr-white);\n    padding: 1.5rem;\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n    text-align: center;\n    flex: 1 1 calc(25% - 1rem); \n    margin: 0.5rem; \n    transition: var(--transition);\n    cursor: pointer;\n    max-width: 100%; \n}\n\n.summary-card h3 {\n    color: var(--clr-primary-5);\n    font-size: 1.25rem;\n    margin-bottom: 0.5rem;\n}\n\n.summary-card p {\n    color: var(--clr-grey-2);\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\n.summary-card:hover {\n    transform: translateY(-5px);\n    box-shadow: var(--dark-shadow);\n}\n\n.summary-card:active {\n    transform: translateY(2px);\n    box-shadow: var(--light-shadow);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n    .summary-card {\n        flex: 1 1 calc(33% - 1rem); \n    }\n}\n\n@media (max-width: 768px) {\n    .staff-summary {\n        flex-direction: column;\n        gap: 1rem;\n    }\n    \n    .summary-card {\n        flex: 1 1 100%; \n    }\n}\n\n@media (max-width: 480px) {\n    .summary-card h3 {\n        font-size: 1rem;\n    }\n\n    .summary-card p {\n        font-size: 1.25rem;\n    }\n}\n\n/* Pagination */\n.pagination-nav {\n    display: flex;\n    justify-content: center;\n    margin: 1.5rem 0;\n}\n\n.pagination {\n    display: flex;\n    list-style: none;\n    padding: 0;\n}\n\n.page-item {\n    margin: 0 0.5rem;\n}\n\n.page-link {\n    padding: 0.5rem 1rem;\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: var(--transition);\n}\n\n.page-item.active .page-link {\n    background-color: var(--clr-primary-7);\n}\n\n.page-link:hover {\n    background-color: var(--clr-primary-4);\n}\n\n/* Tabs Navigation */\n.staff-tabs {\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap; \n    gap: 0.5rem;    \n    margin-bottom: 1.5rem;\n    background-color: var(--clr-grey-10);\n    padding: 1rem;\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n  }\n  \n  /* Button class for tab buttons */\n  .staff-tab-btn {\n    flex: 1 1 calc(20% - 1rem); \n    min-width: 120px;         \n    padding: 0.75rem 1.5rem;\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: var(--transition);\n    font-size: 1.1rem;\n    margin: 0.25rem; \n  }\n\n.staff-tab-btn:hover {\n    background-color: var(--clr-primary-6); \n}\n\n/* Active tab class */\n.staff-tab-btn.active {\n    background-color: var(--clr-primary-7); \n    box-shadow: var(--dark-shadow); \n    font-weight: bold; \n}\n\n.staff-tab-btn:focus {\n    outline: none; \n}\n\n/* Class for active tab with a different background */\n.staff-tab-btn.active-tab {\n    background-color: var(--clr-grey-2); \n    box-shadow: var(--dark-shadow); \n    font-weight: bold; \n    color: var(--clr-primary-9); \n}\n\n/* Hover effect for the active tab */\n.staff-tab-btn.active-tab:hover {\n    background-color: var(--clr-grey-1); \n    box-shadow: var(--light-shadow); \n}\n\n.staff-tab-btn:disabled {\n    background-color: #ddd;\n    cursor: not-allowed;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .staff-tab-btn {\n      flex: 1 1 calc(50% - 1rem); /* ✅ 2 per row */\n      padding: 0.75rem;\n      font-size: 0.875rem;\n      text-align: center;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .staff-tab-btn {\n      flex: 1 1 100%; \n      font-size: 0.75rem;\n      padding: 0.5rem;\n    }\n  }\n.staff-tab-btn:hover {\n    background-color: var(--clr-primary-4);\n    box-shadow: var(--dark-shadow);\n}\n\n/* Staff Content */\n.staff-content {\n    padding: 2rem;\n    background-color: var(--clr-white);\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n}\n\n/* Forms */\n.staff-container form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n    background-color: var(--clr-white);\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n}\n  \n.staff-container input[type=\"text\"],\n.staff-container input[type=\"email\"],\n.staff-container input[type=\"number\"] {\n    padding: 0.75rem;\n    border: 1px solid var(--clr-grey-6);\n    border-radius: var(--radius);\n    font-size: 1rem;\n    color: var(--clr-grey-3);\n}\n\n.staff-container select {\n    padding: 0.75rem;\n    border: 1px solid var(--clr-grey-6);\n    border-radius: var(--radius);\n    font-size: 1rem;\n    color: var(--clr-grey-3);\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.staff-container .staff-btn {\n    padding: 0.75rem;\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: var(--transition);\n    font-size: 1rem;\n}\n\n/* Responsive for medium screens (tablets) */\n@media (max-width: 768px) {\n    .staff-container .staff-btn {\n        padding: 0.6rem; \n        font-size: 0.9rem; \n        width: auto; \n    }\n}\n\n/* Responsive for small screens (mobile phones) */\n@media (max-width: 480px) {\n    .staff-container .staff-btn {\n        padding: 0.5rem; \n        font-size: 0.85rem; \n        width: auto; \n    }\n}\n\n.staff-container .staff-btn:hover {\n    background-color: var(--clr-primary-4);\n    box-shadow: var(--dark-shadow);\n}\n\n/* Practitioner List */\n.practitioner-list ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n.practitioner-list li {\n    padding: 1rem;\n    background-color: var(--clr-primary-10);\n    border-radius: var(--radius);\n    margin-bottom: 1rem;\n    box-shadow: var(--light-shadow);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.practitioner-list li span {\n    color: var(--clr-grey-2);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .staff-container form {\n        padding: 1rem;\n    }\n  \n    .practitioner-list li {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n  \n    .practitioner-list li span {\n        margin-bottom: 0.5rem;\n    }\n}\n\n\n/* Banner */\n.banner {\n    padding: 1rem;\n    margin-bottom: 1rem;\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    text-align: center;\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n}\n\n/* Recent Activity Section */\n.recent-activity {\n    margin-top: 2rem;\n    background-color: var(--clr-grey-10);\n    padding: 1.5rem;\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n}\n\n.recent-activity h2 {\n    color: var(--clr-primary-5);\n    margin-bottom: 1rem;\n    text-align: center;\n}\n\n.recent-activity ul {\n    list-style-type: none;\n    padding-left: 0;\n    color: var(--clr-grey-3);\n}\n\n.recent-activity li {\n    margin-bottom: 0.75rem;\n    padding: 0.75rem;\n    background-color: var(--clr-white);\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.activity-added {\n    color: var(--clr-green);\n}\n\n.activity-updated {\n    color: var(--clr-blue);\n}\n\n.activity-removed {\n    color: var(--clr-red);\n}\n\n.timestamp {\n    color: var(--clr-grey-5);\n    font-size: 0.875rem;\n    margin-left: 0.5rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .recent-activity li {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .timestamp {\n        margin-top: 0.5rem;\n    }\n}\n\n/* Empty State Styling */\n.empty-state {\n    text-align: center;\n    padding: 2rem;\n    background-color: var(--clr-white);\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n    color: var(--clr-grey-3);\n}\n\n.empty-state p {\n    margin: 0.5rem 0;\n    font-size: 1rem;\n    color: var(--clr-grey-4);\n}\n\n/* Mini Workflow Container */\n.mini-workflow-container {\n    width: 50%; \n    margin: 0 auto;\n    padding: 15px;\n    background-color: #ffffff;\n    border-radius: 10px;\n    border: 2px solid var(--clr-primary-5);  \n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    text-align: center;\n}\n\n\n.workflow-title {\n    font-size: 1.4rem;\n    font-weight: bold;\n    color: #222;  \n    margin-bottom: 8px;\n}\n\n\n.workflow-description {\n    font-size: 1rem;\n    color: #444; \n    text-align: left;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n\n.workflow-description p {\n    margin: 6px 0;\n    font-weight: 500;\n    /* display: flex; */\n    align-items: center;\n    gap: 10px;\n    color: var(--clr-grey-1);\n    /* font-size: 1rem; */\n}\n\n\n.workflow-icon {\n    color: #ff8c00; \n    font-size: 1.2rem;\n    flex-shrink: 0; \n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n    .mini-workflow-container {\n        width: 90%; \n        padding: 12px;\n    }\n\n    .workflow-title {\n        font-size: 1.2rem;\n    }\n\n    .workflow-description {\n        font-size: 0.95rem;\n    }\n\n    .workflow-icon {\n        font-size: 1rem; \n    }\n}\n\n/* Adjustments for smaller screens */\n@media (max-width: 1024px) {\n    .mini-workflow-container {\n        width: 70%; \n    }\n}\n\n@media (max-width: 768px) {\n    .mini-workflow-container {\n        width: 90%; \n    }\n}\n\n@media (max-width: 480px) {\n    .mini-workflow-container {\n        width: 100%; \n        padding: 8px;\n    }\n}\n\n/* Mini Search Input */\n.mini-search-input {\n    width: 100%; \n    padding: 10px;\n    margin-bottom: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 1rem;\n}\n\n/* Adjust font size for smaller devices */\n@media (max-width: 768px) {\n    .mini-search-input {\n        font-size: 0.9rem; \n    }\n}\n\n/* Mini Search Button */\n.mini-search-btn {\n    padding: 10px 15px;\n    background-color: #009688;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n/* Adjust button size for smaller screens */\n@media (max-width: 768px) {\n    .mini-search-btn {\n        padding: 8px 12px; \n        font-size: 0.9rem;\n    }\n}\n\n/* Country Select */\n.country-select {\n    margin-bottom: 10px;\n}\n\n.country-select select {\n    padding: 8px;\n    font-size: 1rem;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n}\n\n/* Adjust font size for smaller devices */\n@media (max-width: 768px) {\n    .country-select select {\n        padding: 6px;\n        font-size: 0.9rem; \n    }\n}\n\n/* Search Hint */\n.search-hint {\n    font-size: 0.85rem;\n    color: #6c757d;\n    margin-top: 0.5rem;\n    font-style: italic;\n}\n\n/* Adjust search hint font size for smaller devices */\n@media (max-width: 768px) {\n    .search-hint {\n        font-size: 0.75rem;\n    }\n}\n\n\n.unlock-hint {\n    font-size: 0.9rem;\n    color: #ff9800; \n    text-align: center;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    background-color: #fff3e0; \n    padding: 0.5rem;\n    border-radius: 5px;\n    border: 1px solid #ff9800;\n}\n\n.limit-hint {\n    font-size: 1.2rem;\n    color: #ff9800; \n    text-align: center;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    background-color: #fff3e0; \n    padding: 0.5rem;\n    border-radius: 5px;\n    border: 1px solid #ff9800;\n}\n\n/* Custom Summary Section Styling */\n.custom-staff-summary {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); \n    gap: 1.5rem;  \n    margin-top: 1.5rem;\n    padding: 1rem;\n    background-color:var(--red-light);\n    border-radius: 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Custom Summary Card */\n.custom-summary-card {\n    background-color: #fff;\n    border: 1px solid #ddd;\n    padding: 1.5rem;\n    border-radius: 8px;\n    text-align: center;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease;\n    width: 100%; \n    max-width: 100%; \n}\n\n.custom-summary-card:hover {\n    transform: translateY(-5px);  \n}\n\n/* Custom Pagination Styling - Separate container */\n.custom-pagination-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 2rem;  \n}\n\n.custom-pagination {\n    list-style: none;\n    padding: 0;\n    display: flex;\n}\n\n.custom-pagination li {\n    margin: 0 0.5rem;\n}\n\n.custom-pagination .page-link {\n    padding: 0.5rem 1rem;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.custom-pagination .page-item.active .page-link {\n    background-color: #007bff;\n    color: white;\n    border-color: #007bff;\n}\n\n.custom-pagination .page-link:hover {\n    background-color: #f0f0f0;\n}\n\n.custom-summary-title {\n    /* font-size: 1.75rem; \n    font-weight: 600;  */\n    /* color: #007bff;   */\n    color: var(--clr-primary-5);\n    margin-bottom: 0.75rem; \n    letter-spacing: 0.5px; \n    text-transform: capitalize; \n    transition: color 0.3s ease; \n}\n\n.custom-summary-title:hover {\n    /* color: #0056b3;  */\n    color: var(--clr-primary-3);\n}\n\n/* Styling for the h4 (No Practitioner Title) */\n.custom-no-practitioner-title {\n    font-size: 1.5rem; \n    font-weight: 600;  \n    color: #333;  \n    text-align: center;  \n    margin-bottom: 1rem; \n}\n\n/* Styling for the p (No Practitioner Description) */\n.custom-no-practitioner-description {\n    font-size: 1.1rem; \n    font-weight: 400;  \n    color:var(--clr-grey-1);  \n    text-align: center;  \n    margin-bottom: 0.5rem; \n    line-height: 1.5;  \n}\n\n/* Custom Styling for the Manage Practitioners Title */\n.custom-manage-title {\n    color: var(--clr-grey-1); \n    font-size: 2rem;  \n    font-weight: bold; \n    text-align: center;  \n    margin-bottom: 1.5rem; \n    letter-spacing: 0.5px;  \n    padding-bottom: 0.5rem;  \n    margin-top: 4rem;\n}\n\n\n/* Stylings for logging out state */\n\n/* Full Page Container for Logout State */\n.full-page-logout-container {\n    position: fixed; \n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh; \n    background-color: #f8f9fa; \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 999; \n}\n\n.landing-page-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    /* background: var(--clr-primary-8); */\n    font-family: var(--ff-primary);\n    color: var(--clr-grey-1);\n    padding: 1rem;\n  }\n  \n\n/* Center the logout message in the middle */\n.logout-message-container {\n    background-color: #fff8f0;\n    padding: 20px;\n    border-radius: 10px;\n    border: 1px solid #f5c6cb;\n    max-width: 600px;\n    text-align: center;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    animation: slideIn 0.6s ease-out, glowEffect 2s infinite alternate ease-in-out;\n}\n\n/* Title Styling with Color Change Animation */\n.logout-message-title {\n    color: #d9534f;\n    font-size: 1.5rem;\n    font-weight: bold;\n    margin: 0;\n    padding: 0;\n    letter-spacing: 0.5px;\n    animation: colorChange 3s infinite alternate ease-in-out;\n}\n\n/* Slide-in Animation */\n@keyframes slideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-20%);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Glow Effect Animation for the Container */\n@keyframes glowEffect {\n    from {\n        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    }\n    to {\n        box-shadow: 0 4px 25px rgba(217, 83, 79, 0.5);\n    }\n}\n\n/* Pulsating Color Change for Title */\n@keyframes colorChange {\n    from {\n        color: #d9534f;\n    }\n    to {\n        color: #c9302c;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
